import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { useMediaQuery } from "native-base";
import "./style.css";
import { MOBILE_VIEW_WIDTH } from "../../../utils/screens";

const BarCharts = ({ labels = [], data = [], activeTab, horizontal }) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [chartOptions, setChartOptions] = useState({
    options: {
      chart: {
        type: "bar",
      },
      xaxis: {
        categories: labels,
        labels: {
          rotate: 0,
          trim: true,
          maxHeight: 80,
          maxWidth: 100,

          // Stagger labels
          formatter: function (value) {
            return value.length > 15 ? value.substring(0, 15) + "..." : value;
          },
        },
      },
      yaxis: {
        labels: {
          maxWidth: 100,
        },
      },
      toolbar: {
        show: false,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (Number.isInteger(val)) {
              return val.toFixed(0);
            } else {
              return val.toFixed(2);
            }
          },
        },
      },
      plotOptions: {
        bar: {
          horizontal: horizontal,
          dataLabels: {
            position: "top",
            enabled: true,
          },
        },
      },
      colors: activeTab === "event" ? ["#5fcbef"] : ["#90c226"],
    },
    series: [],
  });

  useEffect(() => {
    if (labels.length > 0 && data.length > 0) {
      const formattedData = data[0].data.map((val) =>
        parseFloat(val).toFixed(2)
      );
      setChartOptions({
        ...chartOptions,
        series: [
          {
            data: formattedData,
          },
        ],
      });
    }
  }, [labels, data]);

  return (
    <div
      className="App"
      style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }}
    >
      <div style={{ height: "auto", width: "100%" }}>
        <Chart
          options={{
            ...chartOptions.options,
            tooltip: {
              ...chartOptions.options.tooltip,

              // Define a callback function to customize the tooltip label dynamically
              custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const formattedValue = Number.isInteger(
                  data?.[0]?.data[dataPointIndex]
                )
                  ? data?.[0]?.data[dataPointIndex]
                  : data?.[0]?.data[dataPointIndex].toFixed(2);

                return `
          <div style="padding: 10px;">
            <div style="display: flex;">
              <div style="width: 10px; height: 10px; background-color: ${
                activeTab === "event" ? "#5fcbef" : "#90c226"
              }; border-radius: 50%; margin-right: 10px; margin-top: 6px"></div>
              ${labels[dataPointIndex]}: 
              &nbsp;&nbsp;<b>${formattedValue}</b>
            </div>
          </div>`;
              },
            },
          }}
          series={chartOptions.series}
          type="bar"
          width={MobileWindow ? 1600 : "100%"}
          height={400}
          className="custom-chart"
        />
      </div>
    </div>
  );
};

export default BarCharts;
